import { Injectable } from '@angular/core';
import {ApiService} from "../global/api.service";
import {Store} from "../../types/models";
import {LeafletCoordinate} from '../../types/thirdparty';
import {DeliveryType} from "../../types/enums";
import {GeoLocation} from "../../types/interfaces";
import {LocationService} from "../core/location.service";
import {isInGeometry} from "../core/geo.util";

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(
    private api: ApiService,
    private locationService: LocationService
  ) { }

  async get(): Promise<Store> {
    return this.api.get('store');
  }

  async getById(storeId: string): Promise<Store> {
    if (!storeId) {
      return null;
    }
    return this.api.get('store/' + storeId);
  }

  async getEmployeeStoreId(): Promise<string> {
    return this.api.get('store/employee');
  }

  async find(addressId: string, params = {}): Promise<Store> {
    if (!addressId) {
      return null;
    }
    return this.api.get(`store/find/${addressId}`, params);
  }

  async getAllDeliveryAreas(): Promise<any[]> {
    return this.api.get('store/delivery-areas');
  }

  async getAllDeliveryAreasForMap(): Promise<{ coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType, geometry?: any }[]> {
    const areas = await this.getAllDeliveryAreas();
    const mapAreas = [];
    for (const area of areas) {
      mapAreas.push({
        deliveryType: area.type,
        coordinate: area.coordinate,
        options: { radius: area.radius},
        geometry: area.geometry || null,
        styleName: 'area'
      });
    }
    return mapAreas;
  }

  findMatchingDeliveryArea(
    areas: { coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType, geometry?: any }[],
    location: GeoLocation
  ): { coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType, geometry?: any } | null {
    for (const area of areas || []) {
      const radius = area?.options?.radius;
      if (!radius || !area.coordinate) {
        continue;
      }
      const distanceInMeters = this.locationService.distance(location, {
        Latitude: area.coordinate.lat,
        Longitude: area.coordinate.lng
      }) * 1000;
      // drawn area: the enclosing circle is only the precheck, the polygon decides
      if (distanceInMeters <= radius && (!area.geometry || isInGeometry(area.geometry, location.Latitude, location.Longitude))) {
        return area;
      }
    }
    return null;
  }
}
